<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :value="value"
    @input="(floorType) => $emit('input', floorType)"
    :reduce="(floorType) => floorType.value"
  />
</template>
<script>
export default {
  name: 'FloorTypeSelect',
  props: {
    value: String,
    id: {
      type: String,
      default: 'floor-type-select',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: {
      type: String,
      default: 'Select a Floor Type',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getFloorTypeOptions();
  },
  methods: {
    getFloorTypeOptions() {
      this.$locationsAPI.getFloorTypeOptions().then((response) => {
        this.options = response.data.floor_type_options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
  },
};
</script>
